import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const DonerSolutionPage = () => {
  useEffect(() => {
    document.title = 'Dürümcü / Dönerci Dijital Çözümü | QR Menü, POS, Online Sipariş, Kurye';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Dürümcü ve dönerciler için hızlı POS, QR menü, kurye takibi ve komisyonsuz online sipariş. Hızlı teslimat, hatasız sipariş akışı.');

    // Canonical
    const canonicalHref = `${siteUrl}/solutions/doner`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Dürümcü/Dönerci Dijital Çözümü',
      serviceType: 'Hızlı Servis Otomasyon Sistemi',
      areaServed: 'TR'
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Dürümcü / Dönerci için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">Yoğun paket sipariş akışını yönetin; hızlı POS, kurye rotası ve QR menü ile hataları azaltın. Online sipariş ile komisyonsuz büyüyün.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>Hızlı POS akışı, ürün varyasyonları ve ek malzemeler</li>
                <li>Kurye navigasyon ve teslimat geçmişi</li>
                <li>Online siparişte yoğunluk yönetimi</li>
                <li>AI ile menü–kampanya önerileri</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Dürümcü/Dönerciler için Modüller</h2>
            <p>Paket yoğunluğu, ek malzeme/opsiyon ve hız beklentisi yüksektir. Bu modüllerle süreci basitleştirin ve hızlandırın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">POS Sistemi</h3>
            <p><a className="text-primary underline" href="/pos-system">POS</a> üzerinde varyasyon ve ek malzeme akışları hızlıca tanımlanır.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş</h3>
            <p><a className="text-primary underline" href="/online-order">Online Sipariş</a> ile yoğun saatlerde komisyonsuz ve hatasız sipariş akışı elde edin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Kurye</h3>
            <p><a className="text-primary underline" href="/courier-system">Kurye</a> ile rota/navigasyon ve teslimat geçmişiyle performansı artırın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">QR Menü</h3>
            <p><a className="text-primary underline" href="/qr-menu">QR Menü</a> ile temassız siparişe geçişi hızlandırın; upsell için görseller kullanın.</p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Ek malzeme ve boy/gramaj seçenekleri destekleniyor mu?</summary>
                <p className="mt-2">Evet. Varyasyon ve opsiyon yapılarıyla esnek tanımlar yapılabilir.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Teslimat gecikmeleri nasıl azaltılır?</summary>
                <p className="mt-2">Kurye rota/navigasyon ve panel haritasındaki “Tüm kuryeleri göster” ile optimizasyon sağlanır.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default DonerSolutionPage;


